import { Route, Routes } from 'react-router';
import RequireAuth from './components/RequireAuth.tsx';
import Landing from './routes/Landing.tsx';
import Login from './routes/auth/Login.tsx';
import Register from './routes/auth/Register.tsx';
import VerifyEmail from './routes/auth/VerifyEmail.tsx';
import ForgotPassword from './routes/auth/ForgotPassword.tsx';
import ResetPassword from './routes/auth/ResetPassword.tsx';
import AcceptInvite from './routes/auth/AcceptInvite.tsx';
import BuilderWizard from './routes/builder/BuilderWizard.tsx';
import PlanEditor from './routes/editor/PlanEditor.tsx';
import PlanList from './routes/plans/PlanList.tsx';
import ShareManager from './routes/share/ShareManager.tsx';
import SharedPlan from './routes/shared/SharedPlan.tsx';
import PlanViewer from './routes/viewer/PlanViewer.tsx';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/shared/:token" element={<SharedPlan />} />
      <Route
        path="/plans"
        element={
          <RequireAuth>
            <PlanList />
          </RequireAuth>
        }
      />
      <Route
        path="/plans/:planId/builder"
        element={
          <RequireAuth>
            <BuilderWizard />
          </RequireAuth>
        }
      />
      <Route
        path="/plans/:planId/edit"
        element={
          <RequireAuth>
            <PlanEditor />
          </RequireAuth>
        }
      />
      <Route
        path="/plans/:planId/share"
        element={
          <RequireAuth>
            <ShareManager />
          </RequireAuth>
        }
      />
      <Route
        path="/plans/:planId/view"
        element={
          <RequireAuth>
            <PlanViewer />
          </RequireAuth>
        }
      />
    </Routes>
  );
}
